import { useState } from 'react';
import { TabBar } from '../../../components/common/TabPanel';
import { ExerciseStepEditor } from '../../../components/exercises/ExerciseStepEditor';
import { TabProps } from '../ExercisePage';
import { Step } from '../useExerciseForm';

export const StepsTab: React.FC<TabProps> = ({ formik }) => {
  const [selectedStepId, setSelectedStepId] = useState(formik.values.steps[0].id);
  const selectedStep = formik.values.steps.find(step => step.id === selectedStepId);

  return (
    <div>
      <TabBar
        editable
        selectedTab={selectedStep?.id || ''}
        onNewTabHandler={() => ({ id: crypto.randomUUID(), label: 'Nieuwe stap', content: '' })}
        onTabsChange={state => formik.setFieldValue('steps', state)}
        onSelectedTabChange={tabId => {
          const tab = formik.values.steps.find(step => step.id === tabId);
          if (tab) setSelectedStepId(tab.id);
        }}
        tabs={formik.values.steps}
      />
      {selectedStep && (
        <ExerciseStepEditor
          name={selectedStep.label}
          content={selectedStep.content}
          platform={formik.values.platform}
          onNameChange={function (name: string): void {
            formik.setFieldValue('steps', replaceStep(formik.values.steps, selectedStep.id, { ...selectedStep, label: name }));
          }}
          onContentChange={function (content: string): void {
            formik.setFieldValue('steps', replaceStep(formik.values.steps, selectedStep.id, { ...selectedStep, content }));
          }}
        />
      )}
    </div>
  );
};

function replaceStep(steps: Step[], id: string, newStep: Step): Step[] {
  return steps.map(step => (step.id === id ? newStep : step));
}
